import React, { Component } from 'react';
// import Paragraph from './paragraph';
// import StudioTourSideInfo from './studioTourSideInfo';

class StudioTourAbout extends Component {
  render() {
    // const { paragraphs, additionalInfo } = this.props.studioTour;
    const { additionalInfo } = this.props.studioTour;

    return (
      <div className="bottomMargin-container">
        {/* Render heading of 1st para only. */}
        {/* {paragraphs[0] && <h2>{paragraphs[0].heading}</h2>} */}
        <h2>19th Annual Artist Studio Tour – 2026</h2>

        {/* <div className="aboutCart-row"> */}
          {/* <div className="aboutCart-p"> */}
            {/* <h3>More info abou the tour</h3> */}
            {/* <a className="h3" href="/events/studio-tour-2026">This years Artists, Locations and Google Map</a> */}
            {/* <br/><br/> */}
          {/* </div> */}
        {/* </div> */}

        <div className="aboutCart-row">
          <div className="aboutCart-p">
            <p>Studio Tour 2026 was wonderfully successful with 22 studios and 36 artists.</p>
            <p>Studio Tour 2027 will most likely be 7/30-8/2.</p>
            <p>To participate you will need to be a Member of the Tahoe Art League.  As a member you will receive all our emails so you'll be informed when sign up begins for the Studio Tour. You can also check our website or follow us on fb or instagram to keep up to date.</p>
            {/* <h3>Participate</h3>
            <p>
              We’re excited to announce that <strong>registration is now open for the 2026 Tahoe Art League Studio Tour (July 31, Aug 1 and 2, 2026)</strong> - one of the most vibrant and well-loved art events in the region!
            </p>
            <p>
              This is a fantastic opportunity to showcase your work, connect with art lovers, and be part of a supportive community of local creatives.
            </p>
            <p>
              <strong>Not a TAL member yet?</strong> No problem - you can purchase your membership <strong>at the same time as you register</strong> for the Studio Tour. It’s quick and easy to do online, and great value.
            </p>
            <p style={{textAlign:'center'}}>You can sign up here:<br/><a href="https://tinyurl.com/3c6wwmv6" target="_blank">Event and Membership Signup</a><br/>(Sign up deadline is May 8th)</p>
            <p>
              This year’s tour will be a fun and energetic three-day event, and we’d love to have you involved!
            </p>
            <p>
              And don’t forget:<br/>
              - you can forward this link to any other artists you think might be interested - if you or they don't have a space, we can help you find a space to show together :)
            </p> */}
            {/* <p> */}
              {/* Be sure to check out this years{' '}
              <a
                href="/assets/studioTourArtists2023.jpg"
                target="_blank"
                rel="noreferrer"
              >
                artists line up
              </a>
              .  */}
              {/* We look forward to seeing you at the Tahoe Art League Gallery:
              3062 Lake Tahoe Boulevard in beautiful South Lake Tahoe. */}
            {/* </p> */}
          </div>
          {/* <StudioTourSideInfo additionalInfo={additionalInfo} /> */}
        </div>
      </div>
    );
  }
}

export default StudioTourAbout;
